import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Tabs } from 'antd';

import './index.less';
import { setWbTabCurrent } from '@store/modules/incubator/wb_tab_current';
import { getIncuBaseList } from '@store/modules/incubator/incubator_list';
import SelectIncubator from '../SelectIncubator';

import TablePayablesCollection from './payables/TableCollection';
import TablePayablesOverdue from './payables/TableOverdue';
import TablePayablesAbnormal from './payables/TableAbnormal';
import TablePayablesPending from './payables/TablePendingrefund';
import TablePayablesPaid from './payables/TablePaid';

import TableContract45 from './contract/Table45';
import TableContractOverdue from './contract/TableOverdue';

import TableAddress45 from './address/Table45';
import TableAddressOverdue from './address/TableOverdue';

import TableCustom45 from './custom/Table45';
import TableCustomOverdue from './custom/TableOverdue';

const { TabPane } = Tabs;
const type = ['押金', '工位收入', '地址收入', '退款'];
const payStatus = ['未付款', '部分匹配', '完成匹配'];
const status = ['待收款', '作废款', '已收款', '未退款', '部分退款', '完成匹配'];

class BenchIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      incuUuid: '',
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { incubatorList, currentShow } = this.props;
    if (incubatorList.length > 0) {
      this.setState({
        incuUuid: currentShow.incuUuid ? currentShow.incuUuid : incubatorList[0].uuid,
      });
    } else {
      this.props.dispatch(getIncuBaseList());
    }
  }

  componentWillReceiveProps(nextProps) {
    const { incubatorList } = nextProps;
    if (incubatorList.length > 0 && incubatorList.length !== this.props.incubatorList.length) {
      this.setState({
        incuUuid: incubatorList[0].uuid,
      });
    }
  }

  componentWillUnmount() {
    const { currentShow } = this.props;
    const { incuUuid } = this.state;
    currentShow.incuUuid = incuUuid;
    this.props.dispatch(setWbTabCurrent(currentShow));
  }

  handleClick = () => {
    this.setState({});
  };

  handleIncuChange = e => {
    this.setState({
      incuUuid: e,
    });
  };

  callback = type1 => key => {
    const { currentShow } = this.props;
    currentShow[type1] = key;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  render() {
    const { incuUuid } = this.state;
    const parentProps = {
      incuUuid,
      type,
      payStatus,
      status,
    };
    const { currentShow } = this.props;
    return (
      <div className="workbench">
        <SelectIncubator onChange={this.handleIncuChange} defaultValue={incuUuid} />
        <Card title="账单提醒" className="mb16">
          <Tabs
            defaultActiveKey={currentShow.billTab || '1'}
            onChange={() => this.callback('billTab')}
          >
            <TabPane tab="催收款" key="1">
              <TablePayablesCollection {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="逾期款" key="2">
              <TablePayablesOverdue {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="异常款" key="3">
              <TablePayablesAbnormal {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="待退款" key="4">
              <TablePayablesPending {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="已到期押金（待处理）" key="5">
              <TablePayablesPaid {...parentProps} pageSize={5} />
            </TabPane>
          </Tabs>
        </Card>
        <Card title="合同提醒" className="mb16">
          <Tabs
            defaultActiveKey={currentShow.contractTab || '1'}
            onChange={() => this.callback('contractTab')}
          >
            <TabPane tab="45天内到期合同" key="1">
              <TableContract45 {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="逾期合同" key="2">
              <TableContractOverdue {...parentProps} pageSize={5} />
            </TabPane>
          </Tabs>
        </Card>

        <Card title="地址提醒" className="mb16">
          <Tabs
            defaultActiveKey={currentShow.addressTab || '1'}
            onChange={() => this.callback('addressTab')}
          >
            <TabPane tab="45天内到期地址" key="1">
              <TableAddress45 {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="逾期地址" key="2">
              <TableAddressOverdue {...parentProps} pageSize={5} />
            </TabPane>
          </Tabs>
        </Card>

        <Card title="客户迁出提醒" className="mb16">
          <Tabs
            defaultActiveKey={currentShow.customTab || '1'}
            onChange={() => this.callback('customTab')}
          >
            <TabPane tab="45天内到期客户" key="1">
              <TableCustom45 {...parentProps} pageSize={5} />
            </TabPane>
            <TabPane tab="逾期客户" key="2">
              <TableCustomOverdue {...parentProps} pageSize={5} />
            </TabPane>
          </Tabs>
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  currentShow: state.wb_tab_current,
  incubatorList: state.incubator_list,
}))(BenchIndex);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/Index.js